import { render, staticRenderFns } from "./goodsImport.vue?vue&type=template&id=06da2b86&scoped=true&"
import script from "./goodsImport.vue?vue&type=script&lang=ts&"
export * from "./goodsImport.vue?vue&type=script&lang=ts&"
import style0 from "./goodsImport.vue?vue&type=style&index=0&id=06da2b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da2b86",
  null
  
)

export default component.exports